module.exports = __webpack_public_path__ + "images/uncharted-4_rgba(0,0,0,0.7).jpg?v=7ed178dc21f2e2c7098ece3e895f7fab";